const styles = theme => ({
  root: {
    marginTop: 30,
    marginLeft: 30,
    marginRight: 30,
    backgroundColor: 'white',
    padding: 20
  },
  formControl: {
    marginTop: 16,
    width: '100%'
  },
  organizationSelect: {
    marginTop: 27,
    width: '100%'
  },
  textField: {
    width: '100%'
  },
  dateGridPadding: {
    marginTop: 16,
    width: '100%'
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

export default styles;


// WEBPACK FOOTER //
// ./src/main/components/styles/FilterStyles.js